export const LEGAL_RIGHT_OF_CANCELLATION: string = `

### <!--= ++sectionIndex -->. Widerrufsrecht

Sie haben im Rahmen Ihrer gesetzlichen Rechte jederzeit das Recht, diesen Vertrag ohne Angabe von Gründen zu widerrufen.

Um Ihr Widerrufsrecht auszuüben, müssen Sie uns eine eindeutige Erklärung (z. B. eine E-Mail) über Ihren Widerrufsentschluss mitteilen. Bitte richten Sie Ihren Widerruf an:

<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

Telefon: Auf Anfrage
E-Mail: <!--= company.mail -->

Zur Bearbeitung Ihrer Anfrage geben Sie bitte folgende Informationen an:

- Ihr vollständiger Name
- Ihre E-Mail-Adresse
- Das Produkt oder die Dienstleistung, die Sie stornieren möchten

Dies wird uns dabei helfen, Ihre Identität zu überprüfen und Ihre Stornierung effektiv zu bearbeiten. Alternativ können Sie Ihr Widerrufsrecht auch direkt über Ihr Benutzerkonto ausüben, wie unter **2. Stornierungsverfahren**.
`;
